var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnimalsBeefOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.503906 19.2312L1.06493 20.7806V26.3998L0.503906 26.4002V19.2312ZM17.9485 26.4006H17.5008V21.5848H18.5655L17.9485 26.4006Z",
    fill: "#CB5E03",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1434 26.3992H20.6742V20.0368V19.5368H20.1742H10.4161C9.84958 19.5368 9.31278 19.4079 8.83396 19.1776V16.7702V16.2702H8.33396H7.29291H6.79291V16.7702C6.79291 17.0688 6.74117 17.374 6.63215 17.6731L6.63183 17.674L4.73298 22.9146L4.67129 23.0848L4.73293 23.2551L5.87141 26.4003H5.2721L0.722441 13.8538C0.722336 13.8535 0.72223 13.8532 0.722125 13.8529C0.572845 13.4358 0.499314 13.012 0.500005 12.5326C0.513732 11.5683 0.905451 10.6479 1.59093 9.96955C2.27691 9.29066 3.20213 8.90846 4.16722 8.9053H22.0542H22.1723L22.2778 8.85251L25.9762 7.00334L26.2535 6.86467L26.2526 6.55459C26.2523 6.47899 26.267 6.40409 26.2957 6.33417C26.3245 6.26424 26.3667 6.20067 26.42 6.14708C26.4733 6.09348 26.5367 6.05093 26.6065 6.02184C26.6761 5.9928 26.7508 5.97775 26.8262 5.97754H29.6575V6.05202L28.3067 6.57819L27.5946 6.85562L28.1341 7.39702L29.2357 8.50259V9.071V9.27746L29.3814 9.42377L31.5 11.5517V12.108C31.5 12.4865 31.1951 12.7904 30.8221 12.7904H26.7196V11.3209V10.8209H26.2196H25.1785H24.6785V11.3209V15.0109L24.6772 15.0122L24.6774 15.2196C24.6782 15.9437 24.497 16.6564 24.1503 17.2922C23.8037 17.9279 23.3027 18.4663 22.6936 18.8578L22.5114 18.9749L22.4722 19.1878L21.1434 26.3992Z",
    stroke: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnimalsBeefOutline);
export default __webpack_public_path__ + "static/media/ic-animals-beef-outline.342ab83bffb11c645ca0399d34fc57e9.svg";
export { ForwardRef as ReactComponent };